<template>
    <!--
        // Page contains
        1)header design
        2)error messages design
        3)Tenant card design
        4)Menu card design
        5)Merge functionality popup
        6)Tenant creation popup
    -->
    <div class="user-home-page dashboard-page">

        <header4IQ :fromapp="'ug'" :pagename="'tenants'"></header4IQ>

        <!-- This is for errors or messages -->
        <Snackbar
            v-if="showSnackbar"
            :snackbarColor="snackbarColor"
            :snackbarMessage="snackbarMessage"
            @close="closeSnackbar()"
        >
        </Snackbar>
        <!-- END - This is for errors or messages -->

        <AdvancedSearch :enablePopup="advancedSearchPopUp" @togglepopup="(val) => advancedSearchPopUp = val"/>
        <main class="main-container" v-if="!advancedSearchPopUp">
            <!-- Tenant page Container Head -->
            <section class="container-head">
                <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                        <v-flex xl12 class="tenant_tool_bar">
                            <v-toolbar style="color:indigo;" dense flat color="#EFEFEF">
                                <!-- <v-toolbar-title>Companies( {{ getTenantsData.length }} )</v-toolbar-title> -->

                                <v-btn-toggle v-model="page" borderless mandatory>
                                    <v-btn value="tenants">
                                        <span class="hidden-sm-and-down">Tenants ( {{ getTenantsData.filter(item => enableAdvancedSearch? getFilteredTenantIds.includes(item.pk) : true).length }} )</span>
                                    </v-btn>
                                </v-btn-toggle>

                                <v-spacer></v-spacer>
                                <span style="display:flex;">
                                    <v-icon title="Search" id="enableSearch" color='#4f2e88' @click="enableSearch = true">search</v-icon>&nbsp; &nbsp;
                                    <v-text-field v-if="enableSearch" label="Search" id="closeSearch" append-icon="clear" @click:append="resetSearchText" autofocus v-model="searchText"></v-text-field>
                                </span>
                                <span style="display:flex;"  v-if="!isSuperUser">
                                    <v-icon title="Advanced Search" id="enableSearch" :color="enableAdvancedSearch ? '#e34d25' : '#4f2e88'" @click="(advancedSearchPopUp = !advancedSearchPopUp)">zoom_in</v-icon>&nbsp; &nbsp; 
                                </span>
                                <span style="display:flex;">
                                    <div class="label-temp"> Temperature</div>&nbsp; &nbsp;
                                    <v-select v-model="temperatureSelected" id="temperatureDropdown" :items="temperatureListDropdown" class="temperature_select"></v-select>&nbsp; &nbsp;   
                                </span>
                                <span id="includeDisabledTenants" style="cursor:pointer;" @click="disableTenants = !disableTenants"> 
                                        <v-icon color='#4f2e88'>{{ disableTenants ? 'check_box' : 'check_box_outline_blank'}}</v-icon>
                                        <span>Include disabled Tenants</span>
                                        <span v-if="!disableTenants">( {{ filterBy(companies.filter(item => enableAdvancedSearch? getFilteredTenantIds.includes(item.pk) : true), searchText , ['name','domain'], true, {'temperature': temperatureSelected}).length - getTenantsData.filter(item => enableAdvancedSearch? getFilteredTenantIds.includes(item.pk) : true).length }} )</span>
                                </span> &nbsp; &nbsp; 
                                <span title="Download All Tenant's Information"> <v-icon color='#4f2e88' id="downloadTenantsInfoBtn" @click="downloadTenantsData()">get_app</v-icon> </span>  &nbsp;  &nbsp;               
                                <span title="Create Tenant" v-if="!isSuperUser"> <v-icon id="tenantCreationBtn" @click="newTenantPopUp()" style="color:#4f2e88;">add</v-icon> </span>
                            </v-toolbar>
                        </v-flex>
                    </v-layout>
                </v-container>
            </section>
            <!-- End - Tenant page Container Head -->

            <!-- Tenants Information in Cards View -->
            <section>
                <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                        <v-flex lg3 v-for="(cmpny, index) in getTenantsData.filter(item => enableAdvancedSearch ? getFilteredTenantIds.includes(item.pk) : true)" :key="cmpny.title">
                            <v-card id="tenantsCard">
                                <v-layout class="tenants-card" :class="cmpny.disabled ? 'disabled' : ''">
                                    <v-flex xs5 class="company-logo" overflow-hidden>
                                        <span v-if="cmpny.logo != null">
                                            <img :src="cmpny.logo" class="logo-img"/>
                                        </span>
                                        <span v-else>
                                            <img src="../../../common/assets/images/default_tenant_image.png" class="logo-img"/>
                                        </span>
                                    </v-flex>
                                    <v-flex xs7 class="company-info" overflow-hidden>
                                        <v-layout>
                                            <v-flex xs12>
                                                <div class="company-name"><b>{{cmpny.domain}}</b></div>
                                                <div class="company-username">{{cmpny.sales_rep || '4iqSales'}}</div>
                                                <div class="a-text"><a target="new">{{cmpny.website || ''}}</a></div>
                                            </v-flex>            
                                        </v-layout>
                                        <v-layout class="card-bottom" row wrap>
                                            <v-flex xs6>
                                                <v-icon @click="switchTenant(cmpny, 'apps')">vpn_key</v-icon>
                                                <span v-if="!enableAdvancedSearch" @click="switchTenant(cmpny, 'apps')">{{cmpny.num_apps || 0}} Tokens</span>
                                                <span v-else @click="switchTenant(cmpny, 'apps')">{{tenantSeperatedDetails[cmpny['schema_name']].app_id.length || 0}} Tokens</span>
                                            </v-flex>
                                            <v-flex xs6>
                                                <v-icon @click="switchTenant(cmpny, 'users')">group</v-icon>
                                                <span v-if="!enableAdvancedSearch" @click="switchTenant(cmpny, 'users')">{{cmpny.num_users || 0}} Users</span>
                                                <span v-else @click="switchTenant(cmpny, 'users')">{{tenantSeperatedDetails[cmpny['schema_name']].user_id.length || 0}} Users</span>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-divider class="temperature lighten-3" :class="cmpny.temperature || 'green'"></v-divider>
                                <v-card-actions>
                                    <h3 v-text="cmpny.name"></h3>
                                    <v-spacer></v-spacer>
                                    <!-- Actions menu -->
                                    <v-menu transition="scale-transition" :close-on-content-click="closeMenu" offset-x right>

                                        <template v-slot:activator="{ on }">
                                            <v-btn icon slot="activator" v-on="on" color="grey" id="openMenuBtn" @click="openMenu(cmpny,index);" v-if="!isSuperUser">
                                                <v-icon>more_vert</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-list class="tenants-list">
                                            <v-list-item @click="switchTenant(cmpny, 'users')">
                                                <v-list-item-title>Users</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="switchTenant(cmpny, 'apps')">
                                                <v-list-item-title>Tokens/Apps</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="editTenant(cmpny)">
                                                <v-list-item-title>Edit</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="SSOConfigurationPopup(cmpny)">
                                                <v-list-item-title>SSO Configuration</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="changeThumbnailPopup(cmpny)">
                                                <v-list-item-title>Change Logo</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item 
                                                @click="showNotesPopup(cmpny)"
                                                @mouseover="closeMenu = true">
                                                <v-list-item-title>Notes</v-list-item-title>
                                            </v-list-item>
                                            <v-divider></v-divider>
                                            <v-list-item @mouseover="closeMenu = false" @click="reset2FA(cmpny)" :class="cmpny['2fa_enabled'] ? 'enabled' :'disabled-2fa'" :title="cmpny['2fa_enabled'] ? 'Click to Disable 2FA' : 'Click to Enable 2FA'">
                                                <v-icon v-if="cmpny['2fa_enabled']" class="done_icon mr-4">done</v-icon>
                                                <v-list-item-title :class="cmpny['2fa_enabled'] ? 'menucontentleftpadding': 'adisabled'" class="authSpacing">2-Factor Authentication</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item v-if="cmpny.disabled" :class="!cmpny.disabled ? 'valid':'invalid'" @mouseover="closeMenu = false" @click="disableTenant(cmpny, 'enable')">
                                                <v-list-item-title >Enable company</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item v-else @mouseover="closeMenu = true" @click="disableTenant(cmpny, 'disable')" :class="cmpny.disabled ? 'valid':'invalid'">
                                                <v-list-item-title>Disable company</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item>
                                                <v-list-item-title>Temperature</v-list-item-title>
                                                <!-- temarature menu -->
                                                <v-menu offset-x  :nudge-right=18>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn icon slot="activator" v-on="on" @mouseover="closeMenu = false" class="gray light" color="grey">
                                                            <v-icon>keyboard_arrow_right</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <v-list class="temparature_menu">
                                                        <v-list-item v-for="color in temperatureList" :key="color" @click="changeTemperature(cmpny, color)">
                                                            <v-icon class="done_icon mr-4" v-if="cmpny.temperature == color">done</v-icon>&nbsp;
                                                            <v-list-item-title class="tmpColor" :class="cmpny.temperature == color ? 'menucontentleftpadding': 'tdisabled'">{{color}}</v-list-item-title>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-menu>
                                                <!-- END - temarature menu -->
                                            </v-list-item>
                                            <v-divider></v-divider>
                                            <v-list-item>
                                                <v-list-item-title :class="cmpny.ticket_link?'':'disabled'"><a target="new" :href="cmpny.ticket_link" class="cmpny_links">Support Tickets</a></v-list-item-title>
                                            </v-list-item>
                                            <v-list-item>
                                                <v-list-item-title :class="cmpny.confluence?'':'disabled'"><a target="new" :href="cmpny.confluence" class="cmpny_links">Confluence</a></v-list-item-title>
                                            </v-list-item>
                                            <v-list-item>
                                                <v-list-item-title :class="cmpny.drive_location?'':'disabled'"><a target="new" :href="cmpny.drive_location" class="cmpny_links">Google Drive Folder</a></v-list-item-title>
                                            </v-list-item>
                                            <v-divider></v-divider>
                                            <v-list-item @click="showMergeTenantPopup(cmpny);">
                                                <v-list-item-title>Merge</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item :class="!cmpny.num_apps?'':'disabled'" @click="deleteTenantPopUp = true">
                                                <v-list-item-title>Delete</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                    <!-- END - Actions menu -->
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </section>
            <!-- END -- Tenants Information in Cards View -->

            <!-- Tenant Merge Dailog -->
            <section>
                <v-dialog v-model="mergeDialog" persistent max-width="600px">
                    <v-card id="mergeTenantsDialog">
                        <div class="user_creation_popup_div">
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <v-card-title >
                                        <span class="headline indigo--text">
                                            <v-icon medium>merge_type</v-icon> Merge with Another Company
                                        </span>
                                    </v-card-title>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-card-text>
                                        <v-flex xs12>
                                            <v-select
                                                id="mergeTenantsDropdown"
                                                :items="companies"
                                                label="Company"
                                                v-model="selectedTenantForMerge"
                                                item-text="name"
                                                item-disabled="customDisabled"
                                                outline>
                                            </v-select>
                                        </v-flex>
                                        <span v-if="selectedTenantForMerge && mergeDialog">* {{selectedTenantForMerge}} will be removed and all apps transferred to {{tenantInfo['name']}}</span><br><br>
                                        <v-flex xs12 v-if="selectedTenantForMerge && mergeDialog">
                                            <v-icon @click="migrateUsers = !migrateUsers" class="pa-0 ma-0" v-text="migrateUsers ? 'check_box': 'check_box_outline_blank'"></v-icon>
                                        <span>Migrate the users( {{companies[(companies.findIndex(x => x.name === selectedTenantForMerge))]['num_users']}} ) from {{selectedTenantForMerge}} to {{tenantInfo['name']}}</span>
                                        </v-flex>
                                </v-card-text>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12  class="save_in_merge">
                                    <v-btn depressed color="grey lighten-3" @click="resetData()">
                                        cancel
                                    </v-btn>
                                    <v-btn :class="selectedTenantForMerge && !disableActionBtn ? '' : 'disabled'" :tabindex="selectedTenantForMerge ? '' : -1"  depressed color="grey lighten-3" @click="mergeTenats()">
                                        Merge
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </div>
                    </v-card>
                </v-dialog>
            </section>
            <!-- END -- Tenant Merge Dailog -->

            <!-- change tumbnail functionality -->
            <section>
                <v-dialog max-width="600px" persistent v-model="changeThumbnail" >
                    <v-card id="changeLogoCard">
                        <div class="user_creation_popup_div">
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <v-card-title >
                                        <span class="headline indigo--text">
                                            <v-icon medium>info_outline</v-icon> Change Logo
                                        </span>
                                    </v-card-title>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 class="pl-3">
                                    <div class="company-logo">
                                        <img :src="thumbnailCompany ? thumbnailCompany['logo'] : '#'" id="profile-img-tag"
                                        class="logo-img" title="Add Logo" />
                                        <input type="file" id="new_logo" name="newCompanyLogo" @change="readURL" onclick = "this.value = null;"
                                        style="display: none;" />
                                    </div>
                                </v-flex>
                                <v-flex class="pl-3">
                                    <v-btn class="change_logo" @click="changeThumbnailPopup()">
                                        Update
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12  class="save_in_merge">
                                    <v-btn depressed color="grey lighten-3" :class="disableActionBtn ? 'disabled' : ''" @click="save_thumbnail_logo()">
                                        Save
                                    </v-btn>
                                    <v-btn depressed color="grey lighten-3" @click="changeThumbnail = false; logoElement = {}">
                                        Cancel
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </div>
                    </v-card>

                </v-dialog>
            </section>
            <!-- END -- change tumbnail functionality -->
            
            <!-- SSO Configuration Creation/Edit PopUP -->
            <section>
                <v-dialog width="60rem" persistent class="show-info-popup" v-model="showSSOConfigurationPopup" >
                    <v-card class="popup-card">
                        <div class="user_creation_popup_div">
                            <div>
                                <v-form  ref="form">
                                    <v-layout row wrap>
                                            <v-flex xs1 class="pa-2 ma-2">
                                                <v-icon class="apps_creation_logo">
                                                    business
                                                </v-icon>
                                            </v-flex>
                                            <v-flex xs10 v-if='editableSSOConfiguration < 0' class="pa-2 ma-2 mt-4 pt-3">
                                                <h3>Edit SSO Configuration</h3>
                                                <h5 v-if="!showAdditionalFields">All fields required *</h5>
                                            </v-flex>
                                            <v-flex xs10 v-else class="pa-2 ma-2 mt-4 pt-3">
                                                <h3>SSO Configuration</h3>
                                                <h5 v-if="!showAdditionalFields">All fields required *</h5>
                                            </v-flex>
                                    </v-layout>
                                    <div v-if="!showAdditionalFields">
                                        <v-layout row wrap>
                                            <v-flex xs3 class="pa-2 ma-2 pt-4">
                                                SSO Configuration
                                            </v-flex>
                                            <v-flex xs8 class="pb-2">
                                                <!-- <v-checkbox v-model="newcmpny.evaluation_tnc" label="EULA"></v-checkbox> -->
                                                <v-radio-group v-model="ssoConfigStatus" row>
                                                    <v-radio
                                                        label="Enable"
                                                        value="enable"
                                                    ></v-radio>
                                                    <v-radio
                                                        label="Disable"
                                                        value="disable"
                                                    ></v-radio>
                                                </v-radio-group>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap>
                                            <v-flex xs3 class="pa-2 ma-2 pt-4">
                                                Identity Provider
                                            </v-flex>
                                            <v-flex xs8 class="pb-2">
                                                <v-radio-group
                                                        :class="ssoConfigStatus == 'disable' ? 'disabled' : ''"
                                                        v-model="selectedIdentityProvider"
                                                        row>
                                                    <v-radio v-for="(idp, index) in identityProviderLabels" :key="index"
                                                        :label="idp.label"
                                                        :value="idp.value"
                                                    ></v-radio>
                                                </v-radio-group>
                                            </v-flex>
                                        </v-layout>
                                        <idpSSOConfigFormVue :ssoConfig="sso_configuration" :identityProvider="selectedIdentityProvider" :enableConfigForm="ssoConfigStatus == 'disable' ? 'disabled' : ''" ref="idpSSOConfigFormRef" @idpSSOConfigFormData="getIdpSSOConfigFormData"></idpSSOConfigFormVue>
                                        <v-layout row wrap>  
                                            <v-flex xs3 class="pa-2 ma-2 pt-4">
                                                {{idpCertificateLabel[selectedIdentityProvider] || 'Certificate'}}
                                            </v-flex>
                                            <v-layout>
                                                <v-btn :class="ssoConfigStatus == 'disable' ? 'disabled' : ''" depressed color="#4f2e88" dark small class="mt-4" @click="uploadCertificateFile()" >Upload file</v-btn>
                                                <input type="file" id="samlCertificate" @change="verifySSOCertFile"
                                                prepend-icon="" style="display: none;"
                                                />
                                                <v-tooltip top>
                                                <template v-slot:activator="{on,attrs}">
                                                <h4 class="certificatefileclass" v-bind="attrs" v-on="on">File name : {{modify_file_name(certificate_file.name) || modify_file_name(sso_configuration.file_name) || '-'}}</h4>
                                                </template>
                                                <span>{{certificate_file.name || sso_configuration.file_name|| 'Upload a file to see file name'}}</span>
                                                </v-tooltip>
                                            </v-layout>
                                        </v-layout>
                                        <v-layout row wrap>
                                            <v-flex xs3 class="pa-2 ma-2 pt-5">
                                                <p title="Synchronize actions with Identity provider">Synchronize configuration</p>
                                            </v-flex>
                                            <v-flex xs4 class="pa-2">
                                                <v-checkbox class=""
                                                    title="Delete user when deleted in Identity provider"
                                                    color="#4f2e88"
                                                    v-model="sso_configuration.sync_deletion" 
                                                    label="Synchronize user deletion">
                                                </v-checkbox>
                                            </v-flex>
                                        </v-layout>
                                    </div>
                                    <div v-else>
                                        <!-- TODO - Find another solution -->
                                        <idpSSOConfigFormVue class="hideIdpConfiguration" :ssoConfig="sso_configuration" :identityProvider="selectedIdentityProvider" :enableConfigForm="ssoConfigStatus == 'disable' ? 'disabled' : ''" ref="idpSSOConfigFormRef" @idpSSOConfigFormData="getIdpSSOConfigFormData"></idpSSOConfigFormVue>
                                        <v-layout row wrap>
                                            <v-flex xs3 class="pa-2 ma-2 pt-4">
                                                Advanced settings
                                            </v-flex>
                                            <v-flex xs8 class="pa-2">
                                                <!-- <pre>{{sso_configuration.additional_fields}}</pre> -->
                                                <textarea :class="ssoConfigStatus == 'disable' ? 'disabled' : ''" id="configurationInfo" class="text_area" v-model="sso_configuration.additional_fields_string"></textarea>
                                            </v-flex>
                                        </v-layout>
                                    </div>
                                    <v-layout row wrap>
                                        <v-flex xs12  class="save_in_app_creation">
                                            <v-spacer></v-spacer>
                                            <v-btn class="ma-3" depressed color="grey lighten-3" id="additionalfieldsBtn" @click="showAdditionalFields = !showAdditionalFields">
                                                <span v-if="!showAdditionalFields">Additional Fields</span>
                                                <span v-else>Back</span>
                                            </v-btn>
                                            <v-btn class="ma-3" depressed color="grey lighten-3" :class="disableActionBtn ? 'disabled' : ''" @click="getIdpSSOConfigEnteredFormData()">
                                                Save
                                            </v-btn>
                                            <v-btn class="ma-3" depressed color="grey lighten-3" @click="cancelEditSSO">
                                                Cancel
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-form >
                            </div>
                        </div>
                    </v-card>
                </v-dialog>
            </section>
            <!-- END SSO Configuration Creation/Edit PopUP -->

            <!-- Tenant Creation/Edit PopUP -->
            <section>
                <v-dialog width="60rem" persistent class="show-info-popup" v-model="showTenantCreationPopup" >
                    <v-card class="popup-card">
                        <div class="user_creation_popup_div">
                            <div>
                                <v-form  ref="form">
                                    <v-layout row wrap>
                                            <v-flex xs1 class="pa-2 ma-2">
                                                <span v-if="newcmpny.logo">
                                                    <img  class="logo-img" :src="newcmpny.logo"  id="profile-img-tag"/>
                                                </span>
                                                <v-icon class="apps_creation_logo" v-else>
                                                    business
                                                </v-icon>
                                            </v-flex>
                                            <v-flex xs10 class="pa-1 ma-2 mt-4 pt-3">
                                                <h3>Tenant</h3>
                                            </v-flex>
                                    </v-layout>
                                    <div v-if="!showAdditionalFields">
                                        <v-layout row wrap>
                                                <v-flex xs3 class="pa-2 ma-2 pt-3">
                                                    Tenant name *
                                                </v-flex>
                                                <v-flex xs8>
                                                        <v-text-field 
                                                            placeholder="Tenant name"  
                                                            v-model="newcmpny.name">
                                                        </v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs3 class="pa-2 ma-2 pt-4">
                                                    Domain/Account ID *
                                                </v-flex>
                                                <v-flex xs8 class="pa-2">
                                                    <v-text-field 
                                                                placeholder="Domain/Account ID"  
                                                                v-model="newcmpny.domain"
                                                                :rules= domainValidation >
                                                    </v-text-field>  
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs3 class="pa-2 ma-2 pt-4">
                                                    Whitelist Domains *
                                                </v-flex>
                                                <v-flex xs8 class="pa-2">
                                                    <v-combobox
                                                        v-model="newcmpny.whitelist_domains"
                                                        label="Whitelist Domains"
                                                        hint="Press Enter to add Domains"
                                                        multiple
                                                        chips
                                                        deletable-chips
                                                        :error-messages="whitelistedDomainsValidate"
                                                    ></v-combobox>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs3 class="pa-2 ma-2 pt-4">
                                                    Type
                                                </v-flex>
                                                <v-flex xs8 class="pa-2">
                                                    <v-select
                                                        v-model="newcmpny.tenant_type"
                                                        :items="tenantTypes"
                                                        item-value="field"
                                                        item-text="displayName"
                                                        v-on:change="setDefaultServer(newcmpny);tenantAgreement='none'"
                                                        >
                                                    </v-select>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap v-if="newcmpny.tenant_type === 'dome' || newcmpny.tenant_type === 'analyzer'">
                                                <v-flex xs3 class="pa-2 ma-2 pt-4">
                                                    Servers
                                                </v-flex>
                                                <v-flex xs8 class="px-2">
                                                    <v-select v-if="newcmpny.tenant_type === 'dome'"
                                                        id="tenantApps"
                                                        :items="domeServersList" 
                                                        v-model="newcmpny.dome_tenant_server"
                                                        item-value="key"
                                                        item-text="display_name"
                                                        label="Dome servers"
                                                        chips
                                                    >
                                                        <template slot="selection"  slot-scope="{ item }">
                                                            <v-chip>
                                                                <span>{{item.display_name}}</span>
                                                            </v-chip>
                                                        </template>
                                                    </v-select>
                                                    <v-select v-if="newcmpny.tenant_type === 'analyzer'"
                                                        id="tenantApps"
                                                        :items="analyzerServersList"
                                                        v-model="newcmpny.analyzer_tenant_server"
                                                        item-value="key"
                                                        item-text="display_name"
                                                        label="Analyzer servers"
                                                        chips
                                                    >
                                                        <template slot="selection"  slot-scope="{ item }">
                                                            <v-chip>
                                                                <span>{{item.display_name}}</span>
                                                            </v-chip>
                                                        </template>
                                                    </v-select>
                                                </v-flex>
                                            </v-layout>
                                            <!-- <v-layout row wrap v-if="newcmpny.tenant_type === 'dome'">
                                                <v-flex xs3 class="pa-2 ma-2 pt-4">
                                                    Enable Evaluation TnC
                                                </v-flex>
                                                <v-flex xs8 class="pa-2">
                                                    <v-layout row wrap>
                                                        <v-flex xs4>
                                                            <v-checkbox v-model="newcmpny.evaluation_tnc"  label="Enable" id="enablepasswordhistory" hide-details></v-checkbox>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout> -->
                                            <v-layout row wrap>
                                                <v-flex xs3 class="pa-2 ma-2 pt-4">
                                                    Agreements
                                                </v-flex>
                                                <v-flex xs8 class="pb-2">
                                                    <!-- <v-checkbox v-model="newcmpny.evaluation_tnc" label="EULA"></v-checkbox> -->
                                                    <v-radio-group v-model="tenantAgreement" row>
                                                        <v-radio
                                                            label="EULA"
                                                            value="eula"
                                                            :class="configuredEula ? '' : 'disabled'"
                                                        ></v-radio>
                                                        <v-radio
                                                            label="EVALUATION"
                                                            value="evaluation"
                                                            :class="configuredEvaluation ? '' : 'disabled'"
                                                        ></v-radio>
                                                        <v-radio
                                                            label="NONE"
                                                            value="none"
                                                        ></v-radio>
                                                    </v-radio-group>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap v-if="tenantAgreement != 'none'">
                                                <v-flex xs3 class="pa-2 ma-2 pt-4">
                                                    {{validateEditTenant?'Agreement Admins *':'Agreement Admins'}}
                                                </v-flex>
                                                <v-flex xs8 class="px-2">
                                                    <v-select
                                                        hide-details
                                                        v-model="newcmpny.end_users"
                                                        :items="newcmpny.users_list"
                                                        multiple
                                                        chips
                                                        >
                                                    </v-select>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs3 class="pa-2 ma-2 pt-4">
                                                    Password History
                                                </v-flex>
                                                <v-flex xs8 class="pa-2">
                                                    <v-layout row wrap>
                                                        <v-flex xs4 class="pl-1">
                                                            <v-checkbox v-model="newcmpny.password_history"  label="Enable" id="enablepasswordhistory" hide-details></v-checkbox>
                                                        </v-flex>
                                                        <v-flex xs2 class="pt-4" v-if="newcmpny.password_history">
                                                            <span>Count</span>
                                                        </v-flex>
                                                        <v-flex xs6 v-if="newcmpny.password_history">
                                                            <v-select
                                                                hide-details
                                                                v-model="newcmpny.password_history_number"
                                                                :items="[1,2,3,4,5,6,7,8,9,10]"
                                                                >
                                                            </v-select>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs3 class="pa-2 ma-2 pt-4">
                                                    Password Expiration
                                                </v-flex>
                                                <v-flex xs8 class="pa-2">
                                                    <v-layout row wrap>
                                                        <v-flex xs4 class="pl-1">
                                                            <v-checkbox v-model="newcmpny.password_expiration" label="Enable" id="passwordExpiration" hide-details></v-checkbox>
                                                        </v-flex>
                                                        <v-flex xs3 class="pt-4" v-if="newcmpny.password_expiration">
                                                            <span>Expiration Days</span>
                                                        </v-flex>
                                                        <v-flex xs5 v-if="newcmpny.password_expiration">
                                                            <v-text-field
                                                                placeholder="Days"
                                                                type="number"
                                                                v-model="newcmpny.password_expiration_days">
                                                            </v-text-field>  
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs3 class="pa-2 ma-2 pt-4">
                                                    Apps Label
                                                </v-flex>
                                                <v-flex xs8 class="pa-2">
                                                    <v-select
                                                        v-model="newcmpny.app_label"
                                                        placeholder="Apps Label"
                                                        :items="appLabels"
                                                        >
                                                    </v-select>
                                                    <!-- <v-text-field
                                                        placeholder="Apps Label"
                                                        v-model="newcmpny.app_label">
                                                    </v-text-field>   -->
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap v-if="appTypesData.length > 0">
                                                <v-flex xs3 class="pa-2 ma-2 pt-4">
                                                    Apps
                                                </v-flex>
                                                <v-flex xs8 class="pa-2">
                                                    <v-select
                                                        id="tenantApps"
                                                        :items="appTypesData"
                                                        v-model="newcmpny.selected_apps"
                                                        item-value="name"
                                                        item-text="display_name"
                                                        label="Apps"
                                                        multiple
                                                        chips
                                                    >
                                                    <template slot="selection"  slot-scope="{ item }">
                                                        <v-chip>
                                                            <span>{{item.display_name}}</span>
                                                        </v-chip>
                                                    </template>
                                                    </v-select>
                                                </v-flex>
                                            </v-layout>
                                        </div>
                                        <div v-else>
                                             <v-layout row wrap>
                                                <v-flex xs3 class="pa-2 ma-2 pt-4">
                                                    Support Ticket
                                                </v-flex>
                                                <v-flex xs8 class="pa-2">

                                                    <v-text-field 
                                                        v-model="newcmpny.ticket_link"
                                                        placeholder="Support Ticket" 
                                                        :error-messages="supportTicketValidate ? '' : 'Not a valid URL or URL did not starts with http or https'">
                                                    </v-text-field>

                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs3 class="pa-2 ma-2 pt-4">
                                                    Sales Rep
                                                </v-flex>
                                                <v-flex xs8 class="pa-2">
                                                    <v-text-field
                                                                placeholder="Sales Rep"  
                                                                v-model="newcmpny.sales_rep" >
                                                    </v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs3 class="pa-2 ma-2 pt-4">
                                                    Website
                                                </v-flex>
                                                <v-flex xs8 class="pa-2">
                                                    <v-text-field
                                                                name="url"
                                                                id="url"
                                                                placeholder="website"  
                                                                v-model="newcmpny.website" >
                                                    </v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs3 class="pa-2 ma-2 pt-4">
                                                    Confluence
                                                </v-flex>
                                                <v-flex xs8 class="pa-2">
                                                <v-text-field
                                                        v-model="newcmpny.confluence"
                                                        placeholder="Confluence"
                                                        :error-messages="confluenceValidate ? '' : 'Not a valid URL or URL did not starts with http or https'">
                                                    </v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs3 class="pa-2 ma-2 pt-4 ">
                                                    Drive location
                                                </v-flex>
                                                <v-flex xs8 class="pa-2">
                                                <v-text-field
                                                        v-model="newcmpny.drive_location"
                                                        placeholder="Drive location"
                                                        :error-messages="driveLocationValidate ? '' : 'Not a valid URL or URL did not starts with http or https'">
                                                    </v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </div>
                                        <v-layout row wrap>
                                            <v-flex xs12  class="save_in_app_creation">
                                                <v-spacer></v-spacer>
                                                <v-btn class="ma-3" depressed color="grey lighten-3" id="additionalfieldsBtn" @click="showAdditionalFields = !showAdditionalFields">
                                                    <span v-if="!showAdditionalFields">Additional Fields</span>
                                                    <span v-else>Back</span>
                                                </v-btn>
                                                <div :class="disableActionBtn? 'disabled' : ''">
                                                <v-btn class="ma-3" depressed color="grey lighten-3" id="addTenantBtn" @click="addNewTenant(newcmpny)" :class="saveButtonValidate ? '' : 'disabled'" tabindex="-1">
                                                    save
                                                </v-btn>
                                                </div>
                                                <v-btn class="ma-3" depressed color="grey lighten-3" id="cancelEditBtn" @click="cancelEdit">
                                                    cancel
                                                </v-btn>
                                            </v-flex>
                                    </v-layout>
                                </v-form >
                            </div>
                        </div>
                    </v-card>
                </v-dialog>
            </section>
            <!-- END -- Tenant Creation PopUP -->
            <confirmationPopupVue 
                v-if="deleteTenantPopUp" 
                :confirmationTitle="'Delete Tenant'"
                :name="tenantInfo.name"
                :confirmationText ="'delete tenant'"
                @action="deleteTenant()"
                @close="closeConfirmationPopUP();">
            </confirmationPopupVue>
            <NotesComponent
                v-if="notesPopup"
                :notesInfo="notesInfo"
                @close="closeNotes();">
            </NotesComponent>
       </main>
   </div>
</template>
<script>
import Vue from 'vue';
import { mapState, mapGetters, mapActions } from 'vuex';
import {formateDate} from '../../../common/assets/utils/formats.js';
import header4IQ from '../../../common/components/header.vue';
import {filterBy} from '../../../common/assets/utils/filters.js';
import {hideLoadIcon,showLoadIcon} from '../../../common/assets/utils/load.js';
import confirmationPopupVue from '../../../common/components/confirmationPopup';
import NotesComponent from "../subcomponents/notes";
import Snackbar from "../../../common/components/snackbar"
import AdvancedSearch from "../subcomponents/AdvancedSearch.vue";
import idpSSOConfigFormVue from './idpSSOConfigForm.vue';

export default {
    name: 'Companies-Component',
    data () {
        return {
            page: 'tenants',
            disableTenants: false,
            enableSearch: false,
            searchText: '',
            newcmpny: {},
            logoElement: {},
            editableTenantIndex: -1,
            editableTenantDomain: null,
            editableTenantName: null,
            showSnackbar: false,
            snackbarColor: null,
            snackbarMessage: null,
            showTenantCreationPopup:false,
            temperatureSelected:'All',
            temperatureListDropdown: ["All","Green","Red","Yellow"],
            temperatureList: ["green","red","yellow"],
            mergeDialog: false,
            selectedTenantForMerge: null,
            deleteTenantPopUp: false,
            changeThumbnail:false,
            thumbnailCompany: null,
            migrateUsers: false,
            closeMenu: true,
            validDomain : false,
            supportTicketValidate : true,
            confluenceValidate : true,
            driveLocationValidate : true,
            domainValidation :[
                v => (/^[a-zA-Z0-9]+(?:-?[a-zA-Z0-9]+)+$/.test(v) ? this.validDomain  = true : this.validDomain = false ) || 'Enter valid domain name'
            ],
            notesPopup:false,
            tenantInfo : {},
            notesInfo : {},
            disableActionBtn : false,
            hide:null,
            appTypesData: [],
            appLabels: ['Companies', 'Apps', 'Organizations'],
            tenantTypes: [
                {
                    field: "standard",
                    displayName: "Standard"
                },
                {
                    field: "dome",
                    displayName: "Hunter+(Dome)"
                },
                {
                    field: "analyzer",
                    displayName: "Analyzer"
                }
            ],
            showAdditionalFields: false,
            password_expiration_days: 30,
            tenantAgreement: 'none',
            domeServersList: [],
            analyzerServersList: [],
            isSuperUser: false,
            showSSOConfigurationPopup: false,
            sso_configuration : {},
            certificate_file : {},
            editableSSOConfiguration: 0,
            ssoIDPIdValidate: false,
            ssoLoginUrlValidate: false,
            ssoLogoutUrlValidate: false,
            validSSOCert: false,
            ssoConfigStatus: '',
            showSecret:false,
            configuredEula:false,
            configuredEvaluation:false,
            eulaevaluationConfiguredList:[],
            cancelIndex:false,
            validateEditTenant:false,
            advancedSearchPopUp:false,
            identityProviderLabels: [
                {label: 'Azure', value: 'azure'},
                {label: 'One Login', value: 'onelogin'},
                {label: 'Okta', value: 'okta'},
            ],
            selectedIdentityProvider: 'azure',
            idpCertificateLabel: { // #TODO move to idpssoform
                'azure': 'Certificate (Base64)',
                'onelogin': 'X.509 Certificate',
                'okta': 'Signing Certificate'
            }
        }
    },
    components: {
        header4IQ,
        confirmationPopupVue,
        NotesComponent,
        Snackbar,
        AdvancedSearch,
        idpSSOConfigFormVue
    },
    created() {
        if(this.companies && this.companies.length === 0){
            this.getTenants();
        }
        this.getAppTypes();
        this.getDomeServers();
        this.organizeData();
    },
    watch:{
        searchText(){
            this.searchText = this.searchText.trimLeft();
        },
        'newcmpny.name'(){
            if(this.newcmpny.name){
                this.newcmpny.name = (this.newcmpny.name).trimLeft()
            }
        },
        loggedInUserInformation() {
            this.organizeData();
        },
        'newcmpny.tenant_type'(){
            if(this.cancelIndex && this.validateEditTenant){
                if(this.newcmpny.users_list.length!=0){
                    this.getconfiguredAgreements(this.newcmpny.tenant_type)
                }
            }
        }
    },
    computed: {
        ...mapState({
            companies: state => state.tenantDetails.allTenants,
            loggedInUserInformation: state => state.loginDetails.loggedInUserInformation,
            enableAdvancedSearch: state => state.advancedSearchDetails.enableAdvancedSearch,
            searchResults: state => state.advancedSearchDetails.searchResults,
            tenantSeperatedDetails: state => state.advancedSearchDetails.tenantSeperatedDetails
        }),
        getFilteredTenantIds(){
            let filtered_tenant_ids = this.searchResults.map( i => i.tenant_id)
            let unique_tenant_ids = [...new Set(filtered_tenant_ids)]
            return unique_tenant_ids
        },
        getTenantsData(){
            return this.filterBy(this.companies, this.searchText , ['name','domain'], this.disableTenants, {'temperature': this.temperatureSelected});
        },
        whitelistedDomainsValidate(){
            var self = this;
            if(self.newcmpny.whitelist_domains){
                for(let i=0;i<self.newcmpny.whitelist_domains.length;i++){
                    const domain = self.newcmpny.whitelist_domains[i];
                    const dotIndex = domain.indexOf('.');
                    if(dotIndex < 1 || !(/^[a-zA-Z0-9]+(?:-?[a-zA-Z0-9]+?\.)+[a-zA-Z0-9]{2,10}$/.test(domain)) || !(/^[a-zA-Z0-9.-]{2,60}$/.test(domain))){
                        return domain+' is not a valid domain name';
                    }
                }
            }
            return null;
        },
        saveButtonValidate(){
            const self = this;
            if(self.newcmpny.name && self.validDomain == true && self.whitelistedDomainsValidate == null && (self.newcmpny.whitelist_domains && self.newcmpny.whitelist_domains.length) 
            && ((!self.validateEditTenant && !self.newcmpny.end_users.length) || (self.validateEditTenant && self.newcmpny.end_users.length) || (self.tenantAgreement == 'none'))){
                return true;
            }
            return false;
        }
    },
    methods: {
        ...mapActions({
            initializeData: 'loginDetails/initializeData',
            getTenants: 'tenantDetails/getAllTenantsData',
            syncTenantsData: 'tenantDetails/syncTenantsData',
        }),
        getconfiguredAgreements(type){
            var self = this;
            Vue.http.get('/get_tenant_agreement_configuration/', {
            params:{
                'type':type,
            }
            }).then((res)=>{
                try {
                    self.eulaevaluationConfiguredList = res.data.data;
                    self.configuredEula = false;
                    self.configuredEvaluation = false;
                    if(self.eulaevaluationConfiguredList.includes('eula') && self.eulaevaluationConfiguredList.includes('non_eula_users')){
                            self.configuredEula = true;
                    }
                    if(self.eulaevaluationConfiguredList.includes('evaluation') && self.eulaevaluationConfiguredList.includes('non_evaluation_users')) 
                    {
                            self.configuredEvaluation = true;
                    }
                } catch (err){
                    console.log(err);
                }
            },(error)=>{
                self.configuredEula = false;
                self.configuredEvaluation = false;
                self.displaySnackbar('error-banner',"Tenant agreements configuration failed");
            });
         },
        setDefaultServer(cmpny){
            if(cmpny.tenant_type == "dome" && cmpny.dome_tenant_server == ""){
                for( let serverIndex in this.domeServersList){
                    if(this.domeServersList[serverIndex]["default"] == true){
                        cmpny.dome_tenant_server=this.domeServersList[serverIndex]["key"]
                    }
                }
            }
            else if(cmpny.tenant_type == "analyzer" && cmpny.analyzer_tenant_server == "" ){
                for( let serverIndex in this.analyzerServersList){
                    if(this.analyzerServersList[serverIndex]["default"] == true){
                        cmpny.analyzer_tenant_server=this.analyzerServersList[serverIndex]["key"]
                    }
                }
            }
            else{
                cmpny.tenant_server = "production"
            }
        },
        organizeData() {
            var self = this;
            self.isSuperUser = this.loggedInUserInformation ? this.loggedInUserInformation['is_superuser'] : '';
        },
        getAppTypes(){
            var self = this;
            Vue.http.get('/get_apptypes/')
            .then((res) =>{
                let getAppsData = res.data;
                for(let i=0; i<getAppsData.length; i++) {
                    self.appTypesData[i] = {};
                    self.appTypesData[i]['name'] = getAppsData[i]['fields']['name'];
                    self.appTypesData[i]['display_name'] = getAppsData[i]['fields']['display_name'];
                }
            }, (error) => {
                console.log(error);
            })
        },
        modify_file_name(certificateName){
            if(certificateName){
                if(certificateName.length<50){
                    return certificateName
                }
                return certificateName.substr(0,15)+"..."+certificateName.substr(certificateName.length-15,certificateName.length)
            }
        },
        getDomeServers() {
            var self = this;
            Vue.http.get('/tenant_type_servers_config/')
            .then((res) =>{
                self.domeServersList = res.data['dome'] || [];
                self.analyzerServersList=res.data['analyzer'] || [];
            }, (error) => {
                console.log(error);
            })
        },
        getTenantLogo(tenant){
            if(tenant['logo']){
                return tenant['logo'];
            }else if(tenant['website']){
                return 'http://www.google.com/s2/favicons?domain='+tenant['website'];
            }else{
                return null;
            }
        },
        resetSearchText(){
            var self = this;
            self.enableSearch = false;
            self.searchText = '';
        },
        // Functions to display snackbar for success/error messages
        displaySnackbar(color,message){
            var self = this;
            self.showSnackbar = false;
            setTimeout(function(){
                self.showSnackbar = true;
            },100)
            self.snackbarColor = color;
            self.snackbarMessage = message;
        },
        closeSnackbar(){
            var self = this;
            self.showSnackbar = false;
            self.snackbarColor = null;
            self.snackbarMessage = null;
        },
        // Functions to To Download Tenants information into Excel Sheet
        downloadTenantsData(){
            var self = this, fileData = self.companies.map(row => ({
                NAME:row.name,
                DOMAIN:row.domain,
                WHITELISTED_DOMAIN: row.whitelist_domains ? row.whitelist_domains.join(" | ") : "",
                DISABLED:row.disabled,
                SALES_REP:row.sales_rep,
                NUM_APPS:row.num_apps,
                NUM_USERS:row.num_users,
                WEBSITE:row.website,
                TWO_FACTOR_AUTHENTICATE:row.two_factor_authenticate,
                TEMPERATURE:row.temperature,
                SUPPORT_TICKET:row.ticket_link,
                CONFLUENCE:row.confluence,
                DRIVE_LOCATION:row.drive_location,
                NOTES:row.note
            }));
            let xlsData = self.objectToXls(fileData);
            self.downloadData(xlsData);
        },
        objectToXls(fileData){
            let xlsRows = [], headers = Object.keys(fileData[0]);
            xlsRows.push(headers.join(','));
            //loop over the rows
            for (let row of fileData){
                let values = headers.map(header => {
                    return row[header];
                });
                xlsRows.push(values.join(','));
            }   
            return xlsRows.join('\n');
        },
        downloadData(fileData){
            let blob = new Blob([fileData],{type:'text/xls'});
            let url = window.URL.createObjectURL(blob);
            let aElement = document.createElement('a');
            aElement.setAttribute('hidden','');
            aElement.setAttribute('href',url);
            aElement.setAttribute('download','tenants.xls');
            document.body.appendChild(aElement);
            aElement.click();
            document.body.removeChild(aElement);
        },


        // Create New Tenant Functionality
        newTenantPopUp(){
            var self = this;
            self.editableTenantIndex = -1;
            console.log(self.$refs);
            // self.$refs.form.reset();
            if(self.notesPopup){
                self.notesPopup = false;
            }
            self.showTenantCreationPopup = !self.showTenantCreationPopup;
            self.newcmpny = {
                'name' : '', //tenant name 
                'sales_rep' : '', //sales rep
                'domain':'', //domain or account id
                'whitelist_domains': [], //whitelist domains
                'website': '', //website
                "ticket_link":'', //support link
                "confluence":'',//conflience
                "drive_location":'', //drive location
                "app_label": 'Apps',
                "selected_apps": [],
                "password_history": false,
                "password_history_number": 3,
                "evaluation_tnc": false, //eula 
                "tenant_evaluation": false, //evaluation
                "password_expiration": false,
                "password_expiration_days": 30,
                "tenant_type": 'standard',
                "end_users": [],
                "tenant_server": "",
                "dome_tenant_server":"",
                "analyzer_tenant_server":""
            };
        },

         urlValidation(url, urlvalidate){
            var self = this, test = /^(http|https):\/\/+[\S\.]+(\.[\S\.])+\S+$/.test(url);
            if(url){
                if(url.length && !test){
                    self[urlvalidate] = false;
                    setTimeout(function(){
                        self[urlvalidate] = true;
                    },4000);
                }
                else{
                    self[urlvalidate] = true;
                }
            }
        },
        addNewTenant(company){
            var self = this ,formData = new FormData();
            var tenantData = {
                'name': company.name,
                'sales_rep' : company.sales_rep,
                'domain_name':company.domain,
                'whitelist_domains': company.whitelist_domains ? company.whitelist_domains.join(',') : null,
                'ticket_link':company.ticket_link,
                'confluence':company.confluence,
                'drive_location':company.drive_location,
                'website':company.website,
                'selected_apps': company.selected_apps,
                'app_label': company.app_label || 'Apps',
                'temperature': 'green',
                'action':'save',
                "password_history": company.password_history,
                "password_history_number": company.password_history_number,
                "evaluation_tnc": self.tenantAgreement === 'eula' ? true : false,
                "tenant_evaluation": self.tenantAgreement == 'evaluation' ? true : false,
                "password_expiration": company.password_expiration,
                "password_expiration_days": company.password_expiration_days,
                'tenant_type': company.tenant_type,
                "end_users": self.tenantAgreement != 'none' ? company.end_users : [],
                "tenant_server":company.tenant_server
            };
            if(tenantData.tenant_type == "dome"){
                tenantData.tenant_server = company.dome_tenant_server
            }
            else if(tenantData.tenant_type == "analyzer"){
                tenantData.tenant_server = company.analyzer_tenant_server
            }
            else {
                tenantData.tenant_server = "production"
            }
            if(self.editableTenantIndex >= 0){
                tenantData['name'] = (self.editableTenantName == company.name) ? null : company.name;
                tenantData['domain_name'] = (self.editableTenantDomain == company.domain) ? null : company.domain;
                tenantData['schema_name'] = company.schema_name;
                tenantData['pk'] = company.pk;
                tenantData['action'] = 'update';
            }
            formData.append('json', JSON.stringify(tenantData));
            formData.append('logo', self.logoElement);
            self.urlValidation(self.newcmpny.ticket_link, "supportTicketValidate");
            self.urlValidation(self.newcmpny.confluence, "confluenceValidate");
            self.urlValidation(self.newcmpny.drive_location, "driveLocationValidate");
            if (self.supportTicketValidate && self.confluenceValidate && self.driveLocationValidate){
                self.disableActionBtn = true;
                setTimeout(function(){
                    self.disableActionBtn = false;
                },2000);
                showLoadIcon();
                this.$loading(true);
                Vue.http.post('/create_tenant/', formData)
                .then((res) => {
                    try{
                        let tenantsData = res.data;
                        if(typeof tenantsData['fields']['whitelist_domains'] == 'string'){
                            tenantsData['fields']['whitelist_domains'] = JSON.parse(tenantsData['fields']['whitelist_domains']);
                        }
                        tenantsData['fields']['pk'] = tenantsData['pk'];
                        tenantsData['fields']['domain'] = tenantsData['domain'];
                        tenantsData['fields']['logo'] = self.getTenantLogo(tenantsData['fields']);
                        tenantsData['fields']['2fa_enabled'] = tenantsData['fields']['two_factor_authenticate'];
                        if(self.editableTenantIndex >= 0){
                            var newIndex = self.companies.findIndex(x => x.pk === tenantsData['fields']['pk']);
                            self.$set(self.companies, newIndex, tenantsData['fields']);
                            self.snackbarMessage = "Tenant "+ tenantsData['fields']['name'] +" updated Successfully";
                            self.syncTenantsData({from: 'tenantsPage', updateTenant: true, updatedTenantIndex: newIndex, tenantInfo: tenantsData['fields']});
                        }else{
                            // self.companies.push(tenantsData['fields']);
                            self.snackbarMessage = "Tenant "+ tenantsData['fields']['name'] +" created Successfully";
                            self.syncTenantsData({from: 'tenantsPage', updateTenant: false, tenantInfo: tenantsData['fields']});
                        }
                        self.displaySnackbar('success-banner',self.snackbarMessage);
                        self.newcmpny = {};
                        self.editableTenantIndex = -1;
                        self.showTenantCreationPopup = false;
                        self.logoElement = {};
                    }
                    catch(err){
                        console.log("error is:",err);
                    }
                    finally{
                        self.hide = hideLoadIcon();
                        if(!self.hide){
                            this.$loading(false);
                        }
                    }
                    self.showAdditionalFields = false;
                    self.cancelIndex = false;
                }, (error) => {
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                    self.displaySnackbar('error-banner',error.data.message);
                    self.logoElement = {};
                    self.showAdditionalFields = false;
                })
            }
        },
        cancelEdit(){
            var self = this;
            self.newcmpny = {};
            self.showAdditionalFields = false;
            self.showTenantCreationPopup = false;
            self.validateEditTenant = false;
            self.cancelIndex = false;
            self.editableTenantIndex = -1;
        },

        // Switch to Tenant APPs/Users Page Functionality
        switchTenant(company, route){
            var self = this;
            self.initializeData({schemaName: company.schema_name, route: route});
        },
        openMenu(company,index){
            var self = this;
            self.closeMenu = true,
            self.editableTenantIndex = index;
            self.tenantInfo = {
                'name' : company['name'],
                'domain' : company['domain'],
                'schemaName' : company['schema_name'],
            };
        },
        // EDIT Tenant Functionality
        editTenant(company){
            var self = this;
            self.configuredEula = false;
            self.configuredEvaluation = false;
            self.cancelIndex = true;
            self.validateEditTenant=true;
            self.showTenantCreationPopup = true;
            self.newcmpny = JSON.parse(JSON.stringify(company));
            self.newcmpny['dome_tenant_server']=self.newcmpny['tenant_type'] == "dome" ? self.newcmpny['tenant_server'] : ""
            self.newcmpny['analyzer_tenant_server']=self.newcmpny['tenant_type'] == "analyzer" ? self.newcmpny['tenant_server'] : ""
            self.tenantAgreement = self.newcmpny.evaluation_tnc ?  'eula': self.newcmpny.tenant_evaluation ? 'evaluation' : 'none';
            self.newcmpny.end_users = typeof(self.newcmpny.end_users) === 'string' ?  JSON.parse(company['end_users']) : company['end_users'];
            self.newcmpny.selected_apps = typeof(company.selected_apps) === 'object' ?  company['selected_apps']: JSON.parse(company['selected_apps']) ;
            console.log(company, self.newcmpny);
            self.editableTenantDomain = company.domain;
            self.editableTenantName = company.name;
        },
        changeThumbnailPopup(company){
            var self = this;
            self.changeThumbnail = true;
            self.disableActionBtn = true;
            if(company) {
                self.thumbnailCompany =  company;
                self.editableTenantDomain = company.domain;
            }
            $("input[id='new_logo']").click();
        },
        SSOConfigurationPopup(company){
            var self = this;
            self.sso_configuration={};
            self.sso_configuration.tenant_id = company.pk;
            self.editableSSOConfiguration = 0
            self.ssoConfigStatus = 'disable'
            self.certificate_file = {}
            self.ssoIDPIdValidate= false
            self.ssoLoginUrlValidate= false
            self.ssoLogoutUrlValidate= false
            self.validSSOCert=false
            $("input[id='samlCertificate']").val("")
            self.showAdditionalFields = false
            self.getSSOConfiguration(company)
            self.showSSOConfigurationPopup = true
        },
        getSSOConfiguration(company){
            var self = this, formData = new FormData();
            formData.append('json', JSON.stringify({'tenant_id' : company.pk}));
            showLoadIcon();
            this.$loading(true);
            console.log(company.domain)
            Vue.http.post("/get_tenant_sso_data/", formData)
            .then((res) => {
                try{
                    if(!res.data.no_sso_data){
                        self.sso_configuration = JSON.parse(res.data.sso_data)
                        self.sso_configuration.tenant_id = res.data.tenant_id;
                        self.editableSSOConfiguration = -1;
                        self.ssoConfigStatus = self.sso_configuration.is_enabled ? 'enable' : 'disable';
                        self.selectedIdentityProvider = self.sso_configuration.identity_provider;
                        // console.log(self.sso_configuration.certificate);
                        // console.log(self.sso_configuration.file_name)
                        // console.log('111',typeof(self.sso_configuration.additional_fields));
                        self.sso_configuration.additional_fields_string = JSON.stringify(self.sso_configuration.additional_fields, undefined, 8);
                        // console.log('222',typeof(self.sso_configuration.additional_fields));
                        self.certificate_file = self.sso_configuration.certificate;
                    }
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            },(error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                self.displaySnackbar('error-banner',error.data.message);
            });            
        },
        getIdpSSOConfigFormData(data) {
            var self = this;
            self.sso_configuration.idp_id = data.idp_id || '';
            self.sso_configuration.entity_id = data.entity_id || '';
            self.sso_configuration.login_url = data.login_url || '';
            self.sso_configuration.logout_url = data.logout_url || '';
            self.sso_configuration.idp_api_access = data.idp_api_access || false;
            self.sso_configuration.client_id = data.client_id || '';
            self.sso_configuration.idp_tenant_or_domain_name = data.idp_tenant_or_domain_name || '';
            self.sso_configuration.principle_or_app_id = data.principle_or_app_id || '';
            self.sso_configuration.client_secret = data.client_secret || '';
            self.save_sso_config();
        },
        getIdpSSOConfigEnteredFormData() {
            var self = this;
            self.$refs.idpSSOConfigFormRef.getssoFormData();
        },
        save_sso_config(){
            var self=this;
            self.urlValidation(self.sso_configuration.idp_id, "ssoIDPIdValidate");
            self.urlValidation(self.sso_configuration.login_url, "ssoLoginUrlValidate");
            self.urlValidation(self.sso_configuration.logout_url, "ssoLogoutUrlValidate");
            if(self.sso_configuration.additional_fields_string){
               try{
                self.sso_configuration.additional_fields = JSON.parse(self.sso_configuration.additional_fields_string)
               }
               catch (e) {
                self.displaySnackbar('error-banner',"Please Enter Valid Information");
                return
                }
            }
            self.sso_configuration.is_enabled= self.ssoConfigStatus == 'enable' ? true : false;
            self.sso_configuration.identity_provider = self.selectedIdentityProvider;
            var formData = new FormData();
            let reader = new FileReader();
            var idpApiKeys = self.sso_configuration.client_id &&
                self.sso_configuration.idp_tenant_or_domain_name &&
                self.sso_configuration.principle_or_app_id &&
                self.sso_configuration.client_secret;
            let providers = ['onelogin'];
            if (providers.includes(self.sso_configuration.identity_provider)) {
                self.sso_configuration.entity_id = self.sso_configuration.idp_id;
            }
            var idpGeneralKeys = self.sso_configuration.identity_provider &&
                self.ssoIDPIdValidate &&
                self.ssoLoginUrlValidate &&
                self.ssoLogoutUrlValidate &&
                self.sso_configuration.entity_id;
            let checkFields = idpGeneralKeys && (self.sso_configuration.idp_api_access ? idpApiKeys : true );
            if(checkFields){
                formData.append('tenant_id', self.sso_configuration.tenant_id);
                if(self.editableSSOConfiguration == 0) {
                    self.sso_configuration.action = 'save'
                    if(self.certificate_file && self.validSSOCert) {
                        formData.append('cert', self.certificate_file);
                        self.sso_configuration.file_name = self.certificate_file.name;
                    }
                    else{
                        console.log('cert');
                        self.displaySnackbar('error-banner',"Please Enter Valid Information");
                        return
                    }
                }
                else{
                    self.sso_configuration.action = 'update'
                    if(self.certificate_file && self.validSSOCert) {
                        formData.append('cert', self.certificate_file);
                        self.sso_configuration.file_name = self.certificate_file.name;
                    }
                }
                formData.append('json', JSON.stringify(self.sso_configuration));
                showLoadIcon();
                this.$loading(true);
                Vue.http.post("/add_tenant_sso_data/", formData)
                .then((res) => {
                    try{
                        self.showSSOConfigurationPopup = false;
                        self.sso_configuration = {};
                        self.certificate_file = {};
                        self.snackbarMessage =self.editableSSOConfiguration == 0 ? "Added SSO Data for Tenant Succesfully" : "Updated SSO Data for Tenant Succesfully";
                    }
                    catch(err){
                        console.log("error is:",err);
                    }
                    finally{
                        this.showSecret=false,
                        self.hide = hideLoadIcon();
                        if(!self.hide){
                            this.$loading(false);
                        }
                    }
                    self.displaySnackbar('success-banner',self.snackbarMessage);
                },(error) => {
                    self.hide = hideLoadIcon();
                    self.showSSOConfigurationPopup = false;
                    if(!self.hide){
                        this.$loading(false);
                    }
                    self.displaySnackbar('error-banner',error.data.message);
                });
            } else {
                self.displaySnackbar('error-banner',"Please Enter Valid Information");
            }
        },
        uploadCertificateFile() {
            $("input[id='samlCertificate']").click();
        },
        verifySSOCertFile(e){
            var self=this;
            let fileTypes = ['application/pkix-cert','application/x-x509-ca-cert'];
            self.certificate_file = e.target.files[0] || {};
            if(e && fileTypes.includes(self.certificate_file.type)){
                self.disableActionBtn = false;
                self.validSSOCert = true
            }
            else{
                self.disableActionBtn = true;
                self.validSSOCert = false
                self.displaySnackbar('error-banner',"Please upload Valid certificate type");
            }
        },
        cancelEditSSO(){
            var self = this;
            self.sso_configuration = {};
            self.showAdditionalFields = false;
            self.showSSOConfigurationPopup= false,
            self.editableSSOConfiguration = 0
        },
        readURL(e) {
            var self = this;
            if (e.target.files[0].type == 'image/png' || e.target.files[0].type == 'image/jpeg') {
                self.disableActionBtn = false;
                var reader = new FileReader();
                reader.onload = function (e) {
                    $('#profile-img-tag').attr('src', reader.result);
                }
                self.logoElement = e.target.files[0];
                reader.readAsDataURL(e.target.files[0]);
            }
            else{
                self.disableActionBtn = true;
                self.displaySnackbar('error-banner',"Please upload image files");
            }
        },
         save_thumbnail_logo(){
            var self = this;
            self.changeThumbnail = false;
            // save functionality
            self.addNewTenant(self.thumbnailCompany);
        },
        showNotesPopup(company){
            var self = this;
            self.notesPopup = false;
            setTimeout(function(){
                self.notesPopup = true;
            },1)
            self.notesInfo = {
                'tenant':company['domain'],
                'schemaName':company['schema_name'],
                'notes' : company['note'],
                // removed sessionStorage usage
                // 'username' : sessionStorage.getItem('username'),
                'username' : self.loggedInUserInformation['username'],

                'timeStamp' : new Date()
            }
        },
        closeNotes(){
            var self = this;
            self.notesPopup=false;
            self.tenantInfo={};
            self.notesInfo={};
        },
        reset2FA(company){
            var self = this, formData = new FormData();
            formData.append('json', JSON.stringify({'schema_name' : company.schema_name, 'disable': !company['2fa_enabled']}));
            showLoadIcon();
            this.$loading(true);
            Vue.http.post("/tenants/settings/mfa/update/", formData)
            .then((data) => {
                try{
                    // Handle SnakBar Messages
                    company['2fa_enabled'] = !company['2fa_enabled'];
                    self.snackbarMessage = !company['2fa_enabled'] ? "2FA Disabled for tenant - "+company.name : "2FA Enabled for tenant - "+company.name;
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
                self.displaySnackbar('success-banner',self.snackbarMessage);
            },(error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                self.displaySnackbar('error-banner',error.data.message);
            });
        },
        disableTenant(company, action){
            var self = this, formData = new FormData(); 
            formData.append('json', JSON.stringify({'schema_name': company.schema_name, 'pk': company.pk, 'action' : action}));
            showLoadIcon();
            this.$loading(true);
            Vue.http.post('/disable_tenant/',formData)
            .then((res) => {
                try{
                    if(!company.disabled){
                        self.editableTenantIndex = -1;
                    }
                    company.disabled = !company.disabled;
                    self.newcmpny = {};
                    self.snackbarMessage = "Tenant - " + company.name + (company.disabled ? " Disabled " : " Enabled ") +"Succesfully";
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
                self.displaySnackbar('success-banner',self.snackbarMessage);
            }, (error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                self.displaySnackbar('error-banner',error.data.message);
            })
        },
        changeTemperature(company, color){
            let self = this;
            var tenantData = {
                'tenant_id' : company.pk,
                'temperature' : color
            }
            showLoadIcon();
            this.$loading(true);
            Vue.http.put("/tenant/", tenantData)
            .then((res) => {
                try{
                    company.temperature = color;
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
                self.displaySnackbar('success-banner',res.data.message);
            }, (error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                self.displaySnackbar('error-banner',error.data.message);
            });
            self.newcmpny = {};
        },
        showMergeTenantPopup(company){
            var self = this;
            this.mergeDialog=true;
            company['customDisabled']=true;
        },
        mergeTenats(){
            var self = this, formData = new FormData();
            formData.append('json', JSON.stringify({'merge_tenant_schema_name': self.tenantInfo.schemaName,
                                                    'current_schema_name': self.companies[self.companies.findIndex(x => x.name === (self.companies['name']=self.selectedTenantForMerge))].schema_name,
                                                    'migrateUsers' : self.migrateUsers}));
            showLoadIcon();
            this.$loading(true);
            Vue.http.post('/merge_tenant/', formData)
                .then((res) => {
                    try{
                        self.disableActionBtn = true;
                        setTimeout(function(){
                            self.disableActionBtn = false;
                        },2000)
                        self.getTenants();
                        self.resetData();
                    }
                    catch(err){
                        console.log("error is:",err);
                    }
                    finally{
                        self.hide = hideLoadIcon();
                        if(!self.hide){
                            this.$loading(false);
                        }
                    }
                    self.displaySnackbar('success-banner',res.data.message);
                }, (error) => {
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                    self.displaySnackbar('error-banner',error.data.message);
                })
        },
        resetData(){
            var self = this;
            self.migrateUsers = false;
            self.selectedTenantForMerge = null;
            self.mergeDialog = false;
            self.editableTenantIndex = -1;
            self.companies[self.companies.findIndex(x => x.name === self.tenantInfo['name'])].customDisabled = false
        },
        deleteTenant(){
            var self = this, formData = new FormData();
            formData.append('json',JSON.stringify({'schema_name': self.tenantInfo['schemaName']}))
            showLoadIcon();
            this.$loading(true);
            Vue.http.post('/delete_tenant/', formData)
            .then((res) => {
                try{
                    // removing deleted tenant data from companies list
                    var deletedTenantIndex = self.companies.findIndex(x => x.name == self.tenantInfo['name']);
                    self.companies.splice(deletedTenantIndex,1)

                    self.displaySnackbar('success-banner',res.data.message);

                    self.deleteTenantPopUp = false;
                    self.tenantInfo = {};
                    self.editableTenantIndex = -1;
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            }, (error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                self.displaySnackbar('error-banner',error.data.message);
            })
        },
        closeConfirmationPopUP(){
            var self =  this;
            self.deleteTenantPopUp = false;
            self.tenantInfo = {};
            self.editableTenantIndex = -1;
        },
        formateDate,
        filterBy,
        showLoadIcon,
        hideLoadIcon
    }
}
</script>
<style scoped lang="scss">
.v-toolbar{

    .v-btn:not(.v-btn--depressed):not(.v-btn--flat) {
        will-change: box-shadow;
        box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);
    }
}
.cmpny_links{
    text-decoration:none;
    color:black;
}
.certificatefileclass {
    padding-top: 18px;
    margin-left:20px;
}
.hideIdpConfiguration {
    display: none;
}
</style>
